import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorLocationPostalCode = () => {
  const listPostalcode = useCallback((callback, payload, loadingCallback) => {
    payload = {
      subdistrict_uid: payload,
    }
    ApiService.jsonRequest('/master-postalcode/list', payload, (response) => {
      if (response.status_code === 200) {
        callback(response.data)
      }
      loadingCallback(false)
    })
  }, [])

  return { listPostalcode }
}

export default InteractorLocationPostalCode
